import { render } from "./PageInNav.vue?vue&type=template&id=26e8a0be&scoped=true"
import script from "./PageInNav.vue?vue&type=script&lang=js"
export * from "./PageInNav.vue?vue&type=script&lang=js"

import "./PageInNav.vue?vue&type=style&index=0&id=26e8a0be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e8a0be"]])

export default __exports__